import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import getTypes from './types';

const getActions = storeName => {
    const types = getTypes(storeName);
    const setCardInfo = createAction(types.SET_CARD_INFO);
    const setGiftCards = createAction(types.SET_GIFT_CARDS);
    const setProperties = createAction(types.SET_PROPERTIES);
    const deleteItem = createAction(types.DELETE_ITEM);
    const setErrorsDetails = createAction(types.SET_ERRORS_DETAILS);
    const toggleFieldValue = createAction(types.TOGGLE_FIELD_VALUE);
    const updateGiftCardAmount = createAction(types.UPDATE_GIFT_CARD_AMOUNT);
    const setCardsWithError = createAction(types.SET_CARDS_WITH_ERROR);
    const setValidationParams = createAction(types.SET_VALIDATION_PARAMS);
    const setGiftCardCodeToBeDeleted = createAction(types.SET_GIFT_CARD_CODE_TO_BE_DELETED);
    const askRemovalConfirmation = createAction(types.ASK_REMOVAL_CONFIRMATION);
    const setGiftCardType = createAction(types.SET_GIFT_CARD_TYPE);
    const setIsBalanceCheck = createAction(types.SET_IS_BALANCE_CHECK);

    return {
        ...dynaForms.getActions(storeName),
        setCardInfo,
        setGiftCards,
        setProperties,
        deleteItem,
        setErrorsDetails,
        toggleFieldValue,
        updateGiftCardAmount,
        setCardsWithError,
        setValidationParams,
        setGiftCardCodeToBeDeleted,
        askRemovalConfirmation,
        setGiftCardType,
        setIsBalanceCheck,
    };
};

export default getActions;
